import { filter, includes } from 'lodash/fp';
import { GroupUser } from 'types';

import { getProfileName } from './common';

export const searchByProfileName = (
  filterValue: string,
  users: GroupUser[],
): GroupUser[] =>
  filterValue
    ? filter(
        (user) =>
          includes(
            filterValue.toLowerCase(),
            getProfileName(user.profile).toLowerCase(),
          ) ||
          includes(filterValue.toLowerCase(), user.profile.email.toLowerCase()),
        users,
      )
    : users;
